import get from 'lodash/get'
import type { ReactNode } from 'react'
import React from 'react'
import { EmptyContent } from '../EmptyContent'
import { Alert } from 'react-bootstrap'

export type ErrorContentProps = {
  error?: any
  message?: string | ReactNode
  icon?: string | ReactNode
  action?: ReactNode
}
export const ErrorContent = ({ error, message, icon, action }: ErrorContentProps) => {
  message = message ?? 'Error while loading data...'
  icon = icon ?? 'exclamation-triangle'
  let subMessage: any = ''
  if (typeof error === 'string' || error instanceof String) {
    subMessage = error
  } else {
    subMessage = get(error, 'message')
  }

  return (
    <Alert variant={'danger'}>
      <EmptyContent icon={icon} message={message} subMessage={subMessage} action={action} />
    </Alert>
  )
}
